<script>
import _ from "lodash";

export default {
  name: "TheStudentAchievementsStatementsTable",

  props: {
    achievements: Array,
  },

  data() {
    return {
      itemsPerPage: 999,
      headers: [
        {
          text: 'Номер',
          value: 'Number',
          groupable: false,
          sortable: false,
          width: '20%',
          align: "center",
          cellClass: "text-body-1",
          class: 'rounded-tl-xl',
        },
        {
          text: 'Название',
          value: 'name',
          groupable: false,
          sortable: false,
          width: '45%',
        },
        {
          text: 'Баллы',
          value: 'score',
          groupable: false,
          sortable: false,
          width: '20%',
          divider: true,
        },
        {
          text: 'Файл',
          value: 'file.url',
          groupable: false,
          sortable: false,
          width: '15%',
          align: 'center',
          class: 'rounded-tr-xl',
        },
      ],
    };
  },

  methods: {
    scoreAchievement(achievement) {
      if (_.isNil(achievement.unit) && _.isNil(achievement.subunit)) return 0.0

      if (_.isNil(achievement.subunit)) return achievement.unit.score;
      else return achievement.subunit.score;
    }
  },
}
</script>

<template>
  <v-data-table
    :headers="headers"
    hide-default-footer
    :items="achievements"
    item-key="id"
    :items-per-page="itemsPerPage"
    height="50vh"
    fixed-header
  >
    <template #loading>
      Идет загрузка...
    </template>

    <template #no-data>
      Отсутствуют достижения
    </template>

    <template #item.Number="{item, index}">
      {{achievements.indexOf(item) + 1}}
    </template>

    <template #item.score="{item, index}">
      {{scoreAchievement(item)}}
    </template>

    <template #item.file.url="{item, index}">
      <v-btn
        icon
        small
        :href="item.file.url"
        target="_blank"
      >
        <v-icon small>
          fa-file
        </v-icon>
      </v-btn>
    </template>


  </v-data-table>
</template>

<style scoped>

</style>